import { Lesson } from '../../../api/types/lesson';
import { Profile } from '../../../api/types/profile';
import { DEFAULT_CONFIRM_STARTING_TEXT } from './constants';

export const confirmationTexts = {
  lessons: {
    cancelEditing: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat('discard current changes?');
    },
  },
  contentGroups: {
    cancelEditingForEditItem: () => {
      return 'Please make sure to save any current changes to the content group before editing any items within it. Are you sure you want to proceed?';
    },
    cancelEditing: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat('discard current changes?');
    },
    removeItem: (extraData: Lesson): string => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat(`remove item ${extraData?.id} from the content group?`);
    },
  },
  sections: {
    cancelEditing: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat('discard current changes?');
    },
  },
  users: {
    forceSyncWithRevenueCat: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat(
        "force a sync with RevenueCat? This could mess up user's data in some cases.",
      );
    },
    deleteAccount: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat("delete this user's account?");
    },
    impersonateUser: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat("impersonate this user's account?");
    },
    revertUserImpersonation: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat('remove user impersonation?');
    },
    deleteSurveysAndLearningPaths: () => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat("delete this user's surveys and learning paths?");
    },
    sendPasswordResetEmail: (extraData?: { email: string }) => {
      return DEFAULT_CONFIRM_STARTING_TEXT.concat(`send a password reset email to ${extraData?.email}?`);
    },
    copyUserData: (extraData?: { sourceProfile?: Profile; targetProfile: Profile }) => {
      const targetName = `${extraData?.targetProfile?.firstName || ''} ${
        extraData?.targetProfile?.lastName || ''
      }`.trim();
      const targetLabel = targetName ? `${targetName} (${extraData?.targetProfile?.id})` : extraData?.targetProfile?.id;
      return DEFAULT_CONFIRM_STARTING_TEXT.concat(`copy this user's data onto ${targetLabel}?`);
    },
    copyUserDataDetails: (extraData?: { sourceProfile?: Profile; targetProfile: Profile }) => {
      const targetName = `${extraData?.targetProfile?.firstName || ''} ${
        extraData?.targetProfile?.lastName || ''
      }`.trim();
      return (
        `This will copy the profile data, transactions, purchases, surveys, learning paths and progress from this ` +
        `user onto ${targetName || 'the target user'} (${extraData?.targetProfile?.id}), overwriting any matching ` +
        `data already on that account. Account-specific data (subscription, admin/tester flags, push tokens, device ` +
        `alias) on the target account will NOT be affected. The current account is left fully intact. This cannot be undone.`
      );
    },
  },
};
